<template>
    <div>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-form ref="form" lazy-validation>
            <v-row class="px-4 py-0">
                <!-- First Row -->
                <v-col md="6" sm="6" xs="6" class="pt-0">
                    <v-select
                        v-model="onBoard.platform"
                        :items="platforms"
                        label="Platform"
                        :rules="rules.required"
                    ></v-select>
                      <v-select
                        v-model="onBoard.gatewayName"
                        :items="gateways"
                        label="Gateway Name"
                        :rules="rules.required"
                    ></v-select>
                    <v-text-field
                        v-model="onBoard.salesPerson"
                        label="Sales Person"
                         :rules="rules.required"
                    ></v-text-field>
                    <v-combobox
                        v-model="onBoard.partnerSource"
                        :items="partners"
                        item-text="partnerName"
                        item-value="partnerName"
                        label="Partner Source"
                        small-chips
                    ></v-combobox>
                    <v-text-field
                        v-model="onBoard.transactionFee"
                        label="Transaction Fee"
                         :rules="rules.required"
                    ></v-text-field>
                    <v-text-field
                        v-model="onBoard.serviceFee"
                        label="Service Fee"
                         :rules="rules.required"
                    ></v-text-field>
                    <v-text-field
                        v-model="onBoard.monthlyMinimum"
                        label="Monthly Minimum"
                         :rules="rules.required"
                    ></v-text-field>
                    <v-select
                        v-model="onBoard.vat"
                        label="VAT"
                        :items="vatOptions"
                        :rules="rules.required"
                    ></v-select>
                    <v-select
                        v-model="onBoard.gatewayOnly"
                        label="Gateway Only"
                        :items="gatewayOnlyOptions"
                    ></v-select>

                    <v-combobox
                        v-model="onBoard.division"
                        :disabled="!divisions"
                        :items="divisions"
                        item-text="name"
                        item-value="id"
                        item-key="id"
                        small-chips
                        label="Division Name or UUID"
                        @change="getMerchants($event, 'division')"
                        clearable @click:clear="clearDivision"
                        :rules="rules.characters"
                    ></v-combobox>

                    <v-combobox
                        v-model="onBoard.merchant"
                        :disabled="!onBoard.division"
                        :items="merchants"
                        item-text="name"
                        item-value="id"
                        item-key="id"
                        small-chips
                        label="Merchant Name or UUID"    
                        :rules="rules.characters"
                    ></v-combobox>

                    <v-select
                        v-model="onBoard.transactionCategory"
                        :items="transactionCategory"
                        label="Transaction Category"
                        :rules="rules.required"
                    ></v-select>

                    <v-text-field
                        v-model="onBoard.merchantId"
                        label="Merchant ID"
                        :rules="rules.required"
                    ></v-text-field>

                </v-col>

                <!-- Second Row -->
                <v-col md="6" sm="6" xs="6" class="pt-0">

                    <v-text-field
                        v-model="onBoard.storeId"
                        label="Store ID"
                        :rules="rules.required"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.password"
                        label="Password"
                        :rules="rules.required"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.categoryCode"
                        label="Merchant Category Code"
                        :rules="rules.required"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.url"
                        label="URL"
                        :rules="rules.required"
                    ></v-text-field>

                    <v-select
                        v-model="onBoard.schemes"
                        label="Payment Schemes"
                        :items="schemes"
                        multiple
                        small-chips
                        :rules="rules.multiple"
                    ></v-select>

                    <v-select
                        v-model="onBoard.currencies"
                        label="Currencies"
                        :items="currencies"
                        multiple
                        small-chips
                        :rules="rules.multiple"
                    ></v-select>

                    <v-text-field
                        v-model="onBoard.sfId"
                        label="Sales Force ID"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.email"
                        label="Email"
                        :rules="rules.required"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.firstName"
                        label="First Name"
                        :rules="rules.required"
                    ></v-text-field>

                    <v-text-field
                        v-model="onBoard.surname"
                        label="Surname"
                        :rules="rules.required"
                    ></v-text-field>

                    <v-select
                        v-model="onBoard.recType"
                        label="Recurring Type"
                        :items="recurringTypes"
                        multiple
                        small-chips
                        hint='For "All Transactions" recurring type leave blank'
                        persistent-hint
                    ></v-select>

                    <v-select
                        v-if="onBoard.transactionCategory == 'ECOM'"
                        v-model="onBoard.threeD"
                        label="3D Secure"
                        :items="threeDTypes"
                        multiple
                        small-chips
                        :rules="rules.multiple"
                    ></v-select>
                </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="reset">Reset</v-btn>
                <v-btn color="primary" @click="add">Add</v-btn>
            </v-card-actions>
        </v-form>

        <v-snackbar v-model="snackbar" color="primary">
            {{ result }}
            <v-icon color="white" @click="snackbar = false">mdi-close-circle</v-icon>
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        clearingInstitute: String,
        divisions: Array,
        partners: Array
    },
    data() {
        return {
            rules: { required: [ v => !!v || 'Required' ],
                     multiple: [ v => v.length == 0 ? 'Required' : true ],
                     email: [ v => this.emailRule(v) ],
                     characters: [ v => this.characterRule(v) ]
                    },
            onBoard: { transactionCategory: 'ECOM',
                       merchantCategory: 'RETAIL',
                       url: 'www.',
                       sfId: null,
                       gatewayOnly: 0 },
            vatOptions: [{ value: 0.00, text: '0%'},
                         { value: 0.20, text: '20%'}],
            gatewayOnlyOptions: [{ value: 0, text: 'No'},
                                 { value: 1, text: 'Yes'}],
            gateways: [{value: 'ACI', text: 'ACI'},
                          {value: 'Cybersource', text: 'Cybersource' }],
            schemes: [{ value: 'MASTER', text: 'Mastercard'},
                      { value: 'VISA', text: 'Visa'}],
            recurringTypes: [{ value: 'Non-Rec', text: 'Non-Recurring'},
                             { value: 'Rec', text: 'Recurring'}],
            threeDTypes: [{ value: 'Non-3D', text: 'Non-3D'},
                          { value: '3D', text: '3D'},
                          { value: '3dv2', text: '3D v2'},
                          { value: 'ApplePay', text: 'ApplePay'}],
            currencies: [{ value: 'AED', text: 'AED' },
                         { value: 'AUD', text: 'AUD' },
                         { value: 'CAD', text: 'CAD' },
                         { value: 'COP', text: 'COP' },
                         { value: 'CHF', text: 'CHF' },
                         { value: 'CZK', text: 'CZK' },
                         { value: 'DKK', text: 'DKK' },
                         { value: 'EUR', text: 'EUR' },
                         { value: 'GBP', text: 'GBP' },
                         { value: 'HKD', text: 'HKD' },
                         { value: 'HUF', text: 'HUF' },
                         { value: 'INR', text: 'INR' },
                         { value: 'JPY', text: 'JPY' },
                         { value: 'KRW', text: 'KRW' },
                         { value: 'MYR', text: 'MYR' },
                         { value: 'MXN', text: 'MXN' },
                         { value: 'NOK', text: 'NOK' },
                         { value: 'NZD', text: 'NZD' },
                         { value: 'PLN', text: 'PLN' },
                         { value: 'NZD', text: 'NZD' },
                         { value: 'RON', text: 'RON' },
                         { value: 'RUB', text: 'RUB' },
                         { value: 'SEK', text: 'SEK' },
                         { value: 'SGD', text: 'SGD' },
                         { value: 'THB', text: 'THB' },
                         { value: 'TRY', text: 'TRY' },
                         { value: 'TWD', text: 'TWD' },
                         { value: 'USD', text: 'USD' },
                         { value: 'ZAR', text: 'ZAR' }],
            transactionCategory: [{ value: 'ECOM', text: 'ECOMMERCE' },
                                  { value: 'MOTO', text: 'MOTO'}],
            merchants: null,
            loading: false,
            platforms: [{ value: 'Bespoke', text: 'Bespoke' },
                        { value: 'Magento', text: 'Magento' },
                        { value: 'Shopify', text: 'Shopify' },
                        { value: 'Woocommerce', text: 'Woocommerce' }],
            snackbar: false,
            result: null
        }
    },
    beforeMount() {
       
    },
    methods: {
        listMerchants() {
            axios({
            method: 'post',
            url: 'list-merchants',
            data: { state: 'Live', divisionId: this.onBoard.division.id },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.merchants = response.data.merchants.filter(merchant => merchant)
                                                        .sort((a, b) => a.name.localeCompare(b.name));

                if(this.onBoard.merchant && this.onBoard.merchant !== Object(this.onBoard.merchant)) {
                    this.onBoard.merchant = response.data.merchants.find(merchant => merchant.name == this.onBoard.merchant);
                }
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getMerchants(res, type) {
            if(type == 'division' && res === Object(res)) {
                this.listMerchants();
            }
            else {
                this.merchants = [];
            }
        },
        clearDivision() {
            this.onBoard.merchant = null;
            this.merchants = [];
        },
        emailRule(v) {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(typeof v !== 'undefined' && v)
            {   if(!pattern.test(v)) {
                    return 'Invalid Email address';
                }
                else { 
                    return true;
                }
            } 
            else {
                return true;
            }
        },
        characterRule(v) {
            let pattern = /^[A-Za-z0-9 -]*$/;
            
            if(v !== Object(v)) {
                if(v) {
                    if(!pattern.test(v)) { 
                        return 'Invalid characters';
                    } else { 
                        return true; 
                    }
                } else {
                    return 'Required';
                }
            } else {
                return true;
            }
        },
        add() {
            if(this.$refs.form.validate()) {
                console.log(this.onBoard);
                console.log(this.clearingInstitute);
                axios({
                method: 'post',
                url: 'add-integration',
                data: { clearingInstitute: this.clearingInstitute,
                        onBoard: this.onBoard,
                        userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    if(response.data.id) {
                        this.addPartner();
                        this.result = 'Integration successfully added'
                        this.snackbar = true;
                        this.$refs.form.reset();
                    }
                })
                .catch(e => {
                    this.loading = false;
                    this.errors.push(e)
                })
            }
        },
        reset() {
            this.$refs.form.reset();
        },
        addPartner() {
            if(this.onBoard.partnerSource && this.onBoard.partnerSource.constructor.name === "String") {    
                axios({
                method: 'post',
                url: 'add-partner',
                data: { partner: this.onBoard.partnerSource },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.$emit('refreshPartners', false);
                })
                
            }
        }
    }
}
</script>